import React, { useState, useEffect, ReactNode } from 'react';

export interface NetworkErrorHandlerProps {
  children: ReactNode;
}

const NetworkErrorHandler: React.FC<NetworkErrorHandlerProps> = ({ children }) => {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);
  const [showOfflineMessage, setShowOfflineMessage] = useState<boolean>(false);

  useEffect(() => {
    const handleOnline = (): void => {
      setIsOnline(true);
      setShowOfflineMessage(false);
    };

    const handleOffline = (): void => {
      setIsOnline(false);
      setShowOfflineMessage(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!isOnline && showOfflineMessage) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        fontFamily: '"IBM Plex Sans", -apple-system, BlinkMacSystemFont, sans-serif'
      }}>
        <div style={{
          background: 'rgba(255, 255, 255, 0.15)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          borderRadius: '20px',
          padding: '40px',
          textAlign: 'center',
          maxWidth: '400px',
          margin: '20px'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '20px' }}>📡</div>
          <h2 style={{ 
            color: 'white', 
            fontSize: '24px', 
            fontWeight: '700', 
            marginBottom: '16px',
            margin: 0
          }}>
            İnternet Bağlantısı Yok
          </h2>
          <p style={{ 
            color: 'rgba(255, 255, 255, 0.8)', 
            fontSize: '16px', 
            lineHeight: '1.5',
            marginBottom: '24px',
            margin: '0 0 24px 0'
          }}>
            İnternet bağlantınızı kontrol edin ve tekrar deneyin.
          </p>
          <button 
            onClick={() => window.location.reload()}
            style={{
              background: 'linear-gradient(135deg, #f97316, #dc2626)',
              color: 'white',
              padding: '16px 24px',
              borderRadius: '12px',
              fontWeight: '700',
              fontSize: '16px',
              border: 'none',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 6px 20px rgba(249, 115, 22, 0.4)',
              minWidth: '120px'
            }}
          >
            Tekrar Dene
          </button>
        </div>
      </div>
    );
  }

  return children;
};

export default NetworkErrorHandler;